import React, { Component } from "react";
import {
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import themeLarge from "../component/ThemeLarge";
import Footer from "../component/Footer";

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      errorMessage: "",
      currentUser: null,
      countdown: 10,
    };
  }

  componentDidMount() {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.setState({ currentUser: user }, () => {
          // Start countdown after setting user
          this.startRedirectCountdown();
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { email, password } = this.state;
    const auth = getAuth();

    try {
      const userCred = await signInWithEmailAndPassword(auth, email, password);
      const user = userCred.user;

      localStorage.setItem("user", JSON.stringify(user));
      alert("Logged in successfully!");
      this.props.navigate("/dashboard");
    } catch (error) {
      let errorMessage = error.message; // Default Firebase error message

      // Check if it's a structured error message (like the one you provided)
      try {
        const parsedError = JSON.parse(error.message); // Attempt to parse the error as JSON
        if (parsedError && parsedError.error && parsedError.error.message) {
          errorMessage = parsedError.error.message; // Extract "INVALID_LOGIN_CREDENTIALS"
        }
      } catch (e) {
        // If parsing fails, use Firebase's default error message
      }

      this.setState({
        errorMessage: errorMessage,
      });
    }
  };

  startRedirectCountdown = () => {
    this.countdownInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.countdown <= 1) {
          clearInterval(this.countdownInterval);
          this.props.navigate("/"); // Redirect
          return { countdown: 0 };
        }
        return { countdown: prevState.countdown - 1 };
      });
    }, 1000);
  };

  render() {
    const { email, password, errorMessage, currentUser } = this.state;

    if (currentUser !== null) {
      return (
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{
            background: themeLarge.colors.bg,
            height: "90vh",
            color: themeLarge.colors.text,
            fontFamily: "Kumbh Sans",
            fontSize: themeLarge.fontSize.body,
            textAlign: "center",
            padding: "20px",
          }}
        >
          <p>
            {currentUser.email} already logged in.
            <br />
            Redirecting to home in ({this.state.countdown}) seconds.
          </p>
        </div>
      );
    }

    return (
      <div>
        <div
          className=""
          style={{
            padding: "100px",
            background: themeLarge.colors.bg,
            height: "80vh",
          }}
        >
          {/* Add your login form or Firebase authentication logic here */}
          <p
            className="d-flex justify-content-center pb-2"
            style={{
              color: themeLarge.colors.text,
              fontSize: themeLarge.fontSize.display,
              fontFamily: "Noto Sans",
              fontWeight: "550",
            }}
          >
            Login
          </p>

          {/* login form */}

          <div className="d-flex justify-content-center">
            <form
              onSubmit={this.handleSubmit}
              className="p-4"
              style={{
                borderRadius: "15px",
                width: "400px",
                backgroundColor: themeLarge.colors.secondary,
                boxShadow: themeLarge.shadows.standard,
                color: themeLarge.colors.text,
                fontSize: themeLarge.fontSize.body,
                fontFamily: "Kumbh Sans",
              }}
            >
              {/* Email field */}
              <div className="form-group mb-3">
                <label
                  htmlFor="email"
                  style={{
                    fontFamily: "Kumbh Sans",
                  }}
                >
                  Email address
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={email}
                  onChange={this.handleInputChange}
                  required
                  placeholder="Enter email"
                  style={{
                    borderRadius: "10px",
                  }}
                />
              </div>

              {/* Password field */}
              <div className="form-group mb-3">
                <label
                  htmlFor="password"
                  style={{
                    fontFamily: "Kumbh Sans",
                  }}
                >
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  name="password"
                  value={password}
                  onChange={this.handleInputChange}
                  required
                  placeholder="Enter password"
                  style={{
                    borderRadius: "10px",
                  }}
                />
              </div>

              {/* Error message */}
              {errorMessage && (
                <div className="alert alert-danger" role="alert">
                  {errorMessage}
                </div>
              )}

              {/* Submit button */}
              <button
                type="submit"
                className="btn w-100"
                style={{
                  backgroundColor: themeLarge.colors.primary,
                  borderRadius: "10px",
                  color: themeLarge.colors.bg,
                  fontWeight: "500",
                  fontFamily: "Kumbh Sans",
                }}
              >
                Login
              </button>
            </form>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

function withNavigate(Component) {
  function Wrapper(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  }
  return Wrapper;
}

export default withNavigate(LoginPage);
